import { useMemo } from 'react';

import {
  BreadCrumbs,
  BreadCrumb,
  BreadCrumbsSizesXL,
} from '@picsart/design-system/components/BreadCrumbs';

import { useNavigate } from 'react-router-dom';
import { useTranslator } from '@picsart/rc/services/localization';
import useSingleTemplatesDataStore from 'templates/stores/singleTemplateDataStore';
import templateTitle, { ANALYTICS_NAMES } from '../../../../pages/SingleTemplate/constants';
import useStyles from './styles';

function Navigation() {
  const classes = useStyles();
  const navigate = useNavigate();
  const translate = useTranslator();

  const { templateData } = useSingleTemplatesDataStore(state => ({
    templateData: state.singleTemplateData,
  }));

  const { display_name = '', subtypes = [] } = templateData;

  const subtypeName = subtypes?.[0];

  const modifiedSubtypeName = useMemo(
    () => subtypeName?.replace(/-/g, ' ').replace(/\b\w/g, match => match.toUpperCase()),
    [subtypeName],
  );

  const handleTemplateItemClick = (type: string) => {
    if (type === templateTitle) {
      navigate(`/templates/`);
    } else if (type === subtypeName) {
      navigate(`/templates/search?q=${subtypeName}`);
    }
  };

  return (
    <div className={classes.root} data-pulse-section={ANALYTICS_NAMES.NAVIGATION}>
      <BreadCrumbs size={BreadCrumbsSizesXL}>
        <BreadCrumb
          onClick={() => handleTemplateItemClick(templateTitle)}
          data-pulse-name={ANALYTICS_NAMES.BREAD_CRUMB}
        >
          {translate('Templates')}
        </BreadCrumb>
        <BreadCrumb
          onClick={() => handleTemplateItemClick(subtypeName)}
          data-pulse-name={ANALYTICS_NAMES.BREAD_CRUMB}
        >
          {translate(modifiedSubtypeName)}
        </BreadCrumb>
        {display_name ? (
          <BreadCrumb isActive data-pulse-name={ANALYTICS_NAMES.BREAD_CRUMB}>
            {translate(display_name || '')}
          </BreadCrumb>
        ) : (
          <></>
        )}
      </BreadCrumbs>
    </div>
  );
}

export default Navigation;
